import { CalculatorLink } from '@/components/blog/CalculatorLink'
import { BlogLink } from '@/components/blog/BlogLink'

export default function Article() {
  return (
    <>
      <p>
        WIBOR to jeden z najważniejszych wskaźników finansowych w Polsce, który bezpośrednio
        wpływa na wysokość rat kredytów hipotecznych milionów Polaków. Zrozumienie czym jest
        WIBOR pomoże Ci lepiej zarządzać swoim kredytem i przewidywać zmiany rat.
      </p>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Czym jest WIBOR?</h2>
      <p>
        WIBOR (Warsaw Interbank Offered Rate) to stopa procentowa, po jakiej banki w Polsce
        pożyczają sobie nawzajem pieniądze na rynku międzybankowym. Jest ustalany codziennie
        na podstawie kwotowań największych banków w Polsce.
      </p>
      <p className="mt-3">
        Istnieje kilka odmian WIBORu w zależności od okresu, na jaki banki pożyczają sobie środki:
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li><strong>WIBOR 3M</strong> — stopa na 3 miesiące, najczęściej stosowana w kredytach hipotecznych</li>
        <li><strong>WIBOR 6M</strong> — stopa na 6 miesięcy, druga najpopularniejsza opcja</li>
        <li><strong>WIBOR 1M, 1Y</strong> — rzadziej stosowane w kredytach hipotecznych</li>
      </ul>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Jak WIBOR wpływa na ratę kredytu?</h2>
      <p>
        Oprocentowanie Twojego kredytu hipotecznego składa się z dwóch elementów:
      </p>
      <div className="bg-muted/50 rounded-xl p-4 mt-3 text-center font-semibold text-lg">
        Oprocentowanie = WIBOR + marża banku
      </div>
      <p className="mt-3">
        Na przykład, jeśli WIBOR 6M wynosi 5,85%, a marża Twojego banku to 2,0%, to Twoje
        oprocentowanie wynosi 7,85%. Marża jest stała przez cały okres kredytu, ale WIBOR
        zmienia się — a wraz z nim Twoja rata. Pamiętaj, że oprocentowanie to nie to samo co
        całkowity koszt kredytu — przy porównywaniu ofert patrz na <BlogLink slug="rrso-kredyt-hipoteczny">RRSO</BlogLink>.
      </p>

      <div className="mt-4">
        <CalculatorLink wiborRate={5.85} bankMargin={2.0} section="interest-rate">
          Sprawdź jak WIBOR wpływa na Twoją ratę
        </CalculatorLink>
      </div>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Jak zmieniał się WIBOR?</h2>
      <p>
        WIBOR jest ściśle powiązany ze stopami procentowymi NBP (Narodowego Banku Polskiego).
        Kiedy NBP podnosi stopy — WIBOR rośnie i raty kredytów rosną. Kiedy NBP obniża stopy —
        WIBOR spada i raty maleją.
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li><strong>2020-2021:</strong> WIBOR na historycznie niskim poziomie (~0,2%) — bardzo tanie kredyty</li>
        <li><strong>2022:</strong> Gwałtowny wzrost do ~7% — raty wzrosły nawet dwukrotnie</li>
        <li><strong>2023-2024:</strong> Stopniowe obniżki, WIBOR w okolicach 5,5-6%</li>
        <li><strong>2025-2026:</strong> Dalsze <BlogLink slug="obnizki-stop-procentowych-2026">obniżki stóp procentowych</BlogLink> zależne od decyzji RPP i sytuacji gospodarczej</li>
      </ul>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Co możesz zrobić?</h2>
      <p>
        Nie masz wpływu na WIBOR, ale możesz zminimalizować jego wpływ na Twój budżet:
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li><strong>Negocjuj marżę banku</strong> — to jedyny element oprocentowania, na który masz wpływ. Różnica 0,3% marży to tysiące złotych w skali kredytu</li>
        <li><strong>Rozważ stałe oprocentowanie</strong> — coraz więcej banków oferuje kredyty ze stałą stopą na 5-7 lat</li>
        <li><strong><BlogLink slug="nadplata-kredytu-hipotecznego">Nadpłacaj</BlogLink> gdy WIBOR jest wysoki</strong> — nadpłata jest najkorzystniejsza gdy odsetki są wysokie</li>
        <li><strong>Planuj bufor w budżecie</strong> — zakładaj, że rata może wzrosnąć o 20-30% w wyniku zmian WIBOR</li>
      </ul>

      <div className="mt-4">
        <CalculatorLink wiborRate={7.0} bankMargin={2.0} section="interest-rate">
          Sprawdź jak wyższa rata wpłynęłaby na Twój budżet
        </CalculatorLink>
      </div>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Co dalej z WIBOR-em? Reforma wskaźników 2026-2037</h2>
      <p>
        WIBOR odchodzi do historii. Od 1 stycznia 2027 roku w nowych umowach kredytów
        hipotecznych obowiązuje wyłącznie <BlogLink slug="polstr-zamiast-wibor">POLSTR</BlogLink>{' '}
        — wskaźnik publikowany przez GPW Benchmark, oparty o rzeczywiste transakcje overnight
        zamiast deklaracji banków. Do końca 2027 roku wszystkie istniejące umowy z WIBOR-em
        zostaną automatycznie skonwertowane na POLSTR plus spread korygujący, a 1 stycznia
        2037 roku GPW Benchmark całkowicie zaprzestanie publikacji WIBOR-u i WIBID-u.
      </p>
      <p className="mt-3">
        Dla kredytobiorców kluczowa informacja: konwersja jest <strong>automatyczna</strong>{' '}
        (bez aneksu) i ma być ekonomicznie neutralna — rata nie powinna wzrosnąć z samego
        faktu zmiany wskaźnika. Zmieni się jednak tempo aktualizacji: POLSTR Compound
        odświeża się co miesiąc, podczas gdy WIBOR 3M co kwartał, a WIBOR 6M co pół roku.
      </p>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Podsumowanie</h2>
      <p>
        WIBOR to zmienna stopa bazowa, która wraz z marżą banku tworzy oprocentowanie Twojego
        kredytu. Jego wartość zależy od polityki monetarnej NBP i sytuacji na rynku międzybankowym.
        Rozumiejąc jak działa WIBOR, możesz lepiej planować swój budżet i podejmować świadome
        decyzje dotyczące kredytu hipotecznego.
      </p>

      <div className="mt-4">
        <CalculatorLink section="interest-rate">
          Oblicz swoją ratę z aktualnym WIBORem
        </CalculatorLink>
      </div>
    </>
  )
}
